import React from "react";
import { Button, Modal, Nav, Tab } from "react-bootstrap";
// img
import h1 from "../../../assets/images/hgame.png";
import h2 from "../../../assets/images/hleaderboard.png";
import styles from "./HowToPlay.module.scss";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../hooks/useLanguage";

const HowToPlayPop = ({ playInst, setPlayInst }) => {
  const t = useLanguage();
  const handlePlayInst = () => {
    setPlayInst(!playInst);
  };
  return (
    <>
      <Modal
        show={playInst}
        onHide={handlePlayInst}
        backdrop="true"
        centered
        className={`${styles.HowToPlayPop} bottomPop allow-scroll`}
        keyboard={false}
        scrollable="true"
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={handlePlayInst}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top pb-3 text-center">
              <h5
                className="m-0 text-white d-inline-block  pb-1 px-3"
                style={{ borderBottom: "1px solid #02ADEA" }}
              >
                {t("howtoplay_pop.title")}
              </h5>
            </div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="Game">
              <Nav
                variant="pills"
                className="justify-content-center inline-flex rounded-4 mx-auto p-1 PillsTab"
                style={{
                  background: "#13131b",
                  border: "1px solid #13131b",
                  maxWidth: "max-content",
                }}
              >
                <Nav.Item>
                  <Nav.Link
                    className="d-flex align-items-center justify-content-center p-1 fw-bold"
                    eventKey="Game"
                  >
                    {t("howtoplay_pop.game")}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="d-flex align-items-center justify-content-center p-1 fw-bold"
                    eventKey="Leaderboard"
                  >
                    {t("howtoplay_pop.leaderboard")}
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content style={{ fontSize: 14, lineHeight: "20px" }}>
                <Tab.Pane eventKey="Game">
                  <div className="py-2">
                    <div>
                      <ul className="text-white mb-0" style={{ fontSize: 12 }}>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.first")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.second")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.third")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.fourth")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.fifth")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.sixth")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.seventh")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.eighth")}
                        </li>
                        <li className="">
                          {t("howtoplay_pop.gamepoints.nineth")}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="pb-2 text-center"
                    style={{ marginBottom: 10 }}
                  >
                    <img
                      src={h1}
                      alt=""
                      className="img-fluid object-fit-contain"
                      style={{ height: 280 }}
                    />
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="Leaderboard">
                  <div>
                    <ul className="text-white mb-0" style={{ fontSize: 12 }}>
                      <li className="">
                        {" "}
                        {t("howtoplay_pop.leaderboardpoints.first")}
                      </li>
                      <li className="">
                        {t("howtoplay_pop.leaderboardpoints.second")}{" "}
                      </li>
                      <li className="">
                        {t("howtoplay_pop.leaderboardpoints.third")}
                      </li>
                      <li className="">
                        {" "}
                        {t("howtoplay_pop.leaderboardpoints.fourth")}
                      </li>
                      <li className="">
                        {t("howtoplay_pop.leaderboardpoints.fifth")}
                      </li>
                      <li className="">
                        {t("howtoplay_pop.leaderboardpoints.sixth")}{" "}
                        <Link
                          to="https://bitanica.com/"
                          target="_blank"
                          className="themeClr"
                        >
                          {" "}
                          Bitanica.com
                        </Link>
                        .
                      </li>
                      <li className="">
                        {t("howtoplay_pop.leaderboardpoints.seventh")}
                      </li>
                    </ul>
                  </div>
                  <div className="pb-2 text-center">
                    <img
                      src={h2}
                      alt=""
                      className="img-fluid object-fit-contain"
                      style={{ height: 280 }}
                    />
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default HowToPlayPop;
